import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FdFormComponentsModule } from '../shared/fd-form-components/fd-form-components.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NotFoundComponent } from './not-found.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { MatRadioModule } from '@angular/material/radio';


@NgModule({
  declarations: [
    NotFoundComponent,
  ],
  imports: [
    FdFormComponentsModule,
    CommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FlexLayoutModule,
    PipesModule,
    MatRadioModule
  ],
  providers: [
  ],
})
export class NotFoundModule {
}
